import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { googleAuthLogin } from "../api";
import GoogleSignInButton from "../components/GoogleSignInButton";

export default function RegisterPage({ onLogin }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleGoogleRegister = async (credential) => {
        setLoading(true);
        setError("");
        try {
            const data = await googleAuthLogin(credential);
            onLogin(data);
            navigate("/");
            window.scrollTo(0, 0);
        } catch (err) {
            setError(err.message || "Google sign-in failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 24px" }}>
            <style>{`
                .google-register-box {
                    max-width: 520px;
                    width: 100%;
                    background: var(--paper);
                    border-radius: 22px;
                    border: 1.5px solid var(--border);
                    padding: 40px;
                    animation: fadeUp 0.5s both;
                }
                @media (max-width: 600px) {
                    .google-register-box { padding: 28px !important; }
                }
            `}</style>

            <div className="google-register-box">
                <div style={{ textAlign: "center", marginBottom: 28 }}>
                    <div style={{ fontSize: 48, marginBottom: 10 }}>Google</div>
                    <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 800, color: "var(--ink)", marginBottom: 6 }}>Create Account</h2>
                    <p style={{ fontSize: 13, color: "var(--text3)" }}>
                        Use your Google account to register and sign in instantly.
                    </p>
                </div>

                <div style={{ marginBottom: 18, display: "flex", justifyContent: "center" }}>
                    <GoogleSignInButton
                        mode="signup"
                        onCredential={handleGoogleRegister}
                        onError={(err) => setError(err.message || "Google sign-in failed")}
                    />
                </div>

                {loading && <div style={{ textAlign: "center", fontSize: 13, color: "var(--text3)", marginBottom: 14 }}>Creating your account...</div>}
                {error && <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#DC2626", marginBottom: 18, fontWeight: 600 }}>{error}</div>}

                <div style={{ fontSize: 12, color: "var(--text3)", lineHeight: 1.6, marginBottom: 22, textAlign: "center" }}>
                    By continuing, you agree to our <span style={{ color: "var(--forest)", fontWeight: 600 }}>Privacy Policy</span> and <span style={{ color: "var(--forest)", fontWeight: 600 }}>Terms of Service</span>.
                </div>

                <div style={{ textAlign: "center", fontSize: 13, color: "var(--text3)" }}>
                    Already have access?{" "}
                    <span
                        onClick={() => {
                            navigate("/signin");
                            window.scrollTo(0, 0);
                        }}
                        style={{ color: "var(--forest)", fontWeight: 700, cursor: "pointer" }}
                    >
                        Go to Sign In
                    </span>
                </div>
            </div>
        </div>
    );
}
